import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { ConsultorioHistoricoService } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-historico.service';
import { ConsultorioHistoricoRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-historico.model';

@Injectable({ providedIn: 'root' })
/** Fachada de histórico do consultório privado. */
export class ConsultorioHistoricoFeatureService extends CustomService {
    private readonly core = inject(ConsultorioHistoricoService);

    buscar(params: Pessoa & { idConsultorio: number }): Observable<ConsultorioHistoricoRequest[]> {
        return this.core.buscar(params).pipe(catchError(this.handleError));
    }
}
